import React from "react";
import Experience from "../fieldsSDE/Experience";
import About from "../fieldsSDE/About";
import Projects from "../fieldsSDE/Projects";
import Education from "../fieldsSDE/Education";

const RightConstantSDE = () => {
  return (
    <div>
      <About />
      <Education />
      <Experience />
      <Projects />
    </div>
  );
};

export default RightConstantSDE;
